import Http from "../utils/axios";
const rt = "/api-zendai";
const rtPos = '/api-sce'
// const rt = "/text";
const user = "/user";
import qs from 'qs'
let env = process.env.VUE_APP_CURRENTMODE
export default {
    /*--------全局接口-----------*/
    /*-------E端登录------*/
    login(params) {
        return Http.post(`${rt}${user}/e/login`, params, false);
    },
    posLogin(params){
        return Http.post(`${rtPos}/e/noauth/sessionIdLogin?ERPSessionId=${params}`,"")
    },
    /*-----获取按钮权限列表--------*/
    getButtonResource() {
        return Http.get(`${rt}${user}/v1/e/resource/getButtonResource`, '', false);
    },
    // 获取平台菜单权限列表
    getMenuResource(params) {
        return Http.get(`${rt}${user}/v1/e/application/initLoginResourceTree`,
            params, false
        );
    },
    /*-------E端登出------*/
    logout(params) {
        return Http.get(`${rt}${user}/e/logout`, params, false);
    },
    /*-------修改密码------*/
    modifyPwd(params) {
        return Http.post(`${rt}${user}/v1/e/userInfo/modifyPassword`, params, false);
    },
    // 登录发送短信验证码
    sendVerifyCodeByLogin(params) {
        return Http.get(`${rt}/v1/e/verify/sendVerifyCodeByLogin?mobile=${params}`, false, false)
    },
    // 修改密码发送短信验证码
    sendVerifyCodeByModifyPwd(params) {
        return Http.get(
            `${rt}${user}/v1/e/verify/sendVerifyCodeByModifyPwd?mobile=${params}`,
            false,
            false
        );
    },
    /*------加载所有资源树------*/
    initAllResourceTree(params, param) {
        return Http.get(
            `${rt}${user}/v1/e/resource/initAllResourceTree?${param}`,
            params,
            false
        );
    },
    /*------加载权限树------*/
    listNewTreemallManage(params, param) {
        return Http.get(
            `${rt}/investment/e/mallManage/listNewTree`,
            params,
            false
        );
    },
    /*------保存权限树------*/
    addPrivilegeprivilege(params, param) {
        return Http.post(
            `${rt}${user}/v1/e/privilege/addPrivilege`,
            params,
            false
        );
    },
   
    /*------加载上级资源列表------*/
    getAllResourceList(params, param) {
        return Http.get(`${rt}${user}/v1/e/resource/getAllResourceList?${param}`, params, false);
    },
    /*------新增资源-----------*/
    addResource(params) {
        return Http.post(`${rt}${user}/v1/e/resource/addResource`, params, true);
    },
    /*------更新资源-----------*/
    updateResource(params) {
        return Http.post(`${rt}${user}/v1/e/resource/updateResource`, params, true);
    },
    /*------删除资源-----------*/
    delResource(params) {
        return Http.post(`${rt}${user}/v1/e/resource/deleteResource`, params, true);
    },
    /*------更新资源排序-----------*/
    updateResourceSort(params) {
        return Http.post(`${rt}${user}/v1/e/resource/updateResourceSort`, params, true);
    },
    /*------新增角色------*/
    addRole(params) {
        return Http.post(`${rt}${user}/v1/e/role/saveOrUpdate`, params, false);
    },
    /*------角色详情------*/
    findRoleDetail(params) {
        return Http.post(`${rt}${user}/v1/e/role/findRoleDetail`, params, false);
    },
    // 获取角色拥有的用户列表
    queryUsersByRole(params) {
        return Http.get(
            `${rt}${user}/v1/e/role/getUserListByRoleId`,
            params,
            false
        );
    },
    // 根据应用模块查询菜单和按钮权限
    queryMenuAndButton(params) {
        return Http.post(
            `${rt}${user}/v1/e/application/initResourceTreeByApplicationId`,
            params,
            false
        );
    },
    /*-----------下载页面接口---------*/
    ExcelDownload(params) {
        return Http.post(`${rt}${user}/v1/e/excel/queryExcelDownload`, params, true);
    },
    ExcelModule(params) {
        return Http.post(`${rt}${user}/v1/e/excel/queryExcelModule`, params, false);
    },
    //根据用户loginName获取最新session
    findSysUserInfo(params) {
        return Http.post(`${rt}${user}/v1/e/login/findSysUserInfo`, params, false)
    },
    /*-----------预警管理接口---------*/
    getWarningconfigType(params) {
        return Http.get(`${rt}${user}/v1/e/dict/findList`, params, false);
    },
    queryWarinngList(params) {
        return Http.post(`${rt}${user}/v1/e/mallconfig/api/findPage`, params, false);
    },
    addWarningList(params) {
        return Http.post(`${rt}${user}/v1/e/mallconfig/api/saveOrUpdate`, params, false);
    },
    delWarning(params) {
        return Http.post(`${rt}${user}/v1/e/mallconfig/api/delete`, params, false);
    },
    getWarningDetail(params) {
        return Http.post(`${rt}${user}/v1/e/mallconfig/api/detail`, params);
    },

    /*-----------日志列表---------*/
    querySysLogList(params) { //登陆日志
        return Http.post(`${rt}${user}/v1/e/log/inner/findSysLogPage`, params, false);
    },
    queryBizLogList(params) { //业务日志
        return Http.post(`${rt}${user}/v1/e/log/inner/findBizLogPage`, params, false);
    },
    exportSysLog(params) { //登陆日志导出
        return Http.post(`${rt}${user}/v1/e/log/inner/exportSysLog`, params, false);
    },
    exportBizLog(params) { //业务日志导出
        return Http.post(`${rt}${user}/v1/e/log/inner/exportBizLog`, params, false);
    },
    // 根据sessionid获取用户信息 GET /v1/e/openapi
    getOpenApi(params) {
        return Http.get(`${rt}${user}/v1/e/openapi`, params, false);
    },
    //根据appId获取token GET /v1/e/opentoken
    getOpenToken(params) {
        return Http.get(`${rt}${user}/v1/e/opentoken`, params, false);
    },
    // ERP系统ping /v1/e/ping
    pingErp() {
        return Http.get(`${rt}${user}/v1/e/ping`, "", false);
    },
    // POS系统ping /api-sce/e/ping
    pingPos() {
        return Http.get(`${rtPos}/e/ping`, "", false);
        // return Http.get(`${posUrl}api-sce/e/ping`, "", false);    
    },
    // POS登陆 /api-sce/e/noauth/tokenLogin
    loginPos(params) {
        return Http.post(`${rtPos}/e/noauth/tokenLogin`, params, false);
        // return Http.post(`${posUrl}api-sce/e/noauth/tokenLogin`, params, false);    
    },
    //  
};